


















import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import VideoPointList from './list.vue'
import ViewDialog from '@/components/dialog/viewDialog.vue'

@Component({
  components: { ViewDialog, VideoPointList }
})
export default class VideoPointsManage extends Vue {
  public name = 'VideoPointsManage'
  public showDialog: boolean = false
  public videoId: number = 0
  public $refs!: {
    pointsCtrl: VideoPointList
  }
  public mounted() {
    window.eventBus.$on('openVideoPointsManage', (item: any) => {
      this.showDialog = true
      this.videoId = item.Id
      this.loadData()
    })
  }
  public beforeDestroy() {
    window.eventBus.$off('openVideoPointsManage')
  }
  public close() {
    this.showDialog = false
  }
  //数据加载
  public loadData() {
    /*
      关于 ref 注册时间的重要说明：
      因为 ref 本身是作为渲染结果被创建的，在初始渲染的时候你不能访问它们 - 它们还不存在！
      $refs 也不是反馈式的，因此你不应该试图用它在模板中做数据绑定
      使用 this.$nextTick(() => {}) 等页面渲染好再调用
      */
    this.$nextTick(() => {
      if (this.$refs.pointsCtrl) {
        this.$refs.pointsCtrl.videoId = this.videoId
        this.$refs.pointsCtrl.loadData()
      }
    })
  }
}
